import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BreadcrumbsModule } from 'src/@vex/components/breadcrumbs/breadcrumbs.module';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { AccountsNeedingAttentionWidgetComponent } from './accounts-needing-attention-widget.component';
import { DashboardMetricsComponent } from './dashboard-metrics.component';
import { EnrollmentDuplicatesAlertComponent } from './enrollment-duplicates-alert.component';
import { EnrollmentsAwaitingAcknowledgementWidgetComponent } from './enrollments-awaiting-acknowledgement-widget.component';
import { HomeComponent } from './home.component';
import { MembersOverTimeWidgetComponent } from './members-over-time-widget.component';
import { RecentlyAssignedWidgetComponent } from './recently-assigned-widget.component';
import { UpcomingOpenEnrollmentWidgetComponent } from './upcoming-open-enrollment-widget.component';

@NgModule({
  declarations: [
    HomeComponent,
    DashboardMetricsComponent,
    RecentlyAssignedWidgetComponent,
    UpcomingOpenEnrollmentWidgetComponent,
    AccountsNeedingAttentionWidgetComponent,
    EnrollmentsAwaitingAcknowledgementWidgetComponent,
    MembersOverTimeWidgetComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PageLayoutModule,
    BreadcrumbsModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    NgApexchartsModule,
    EnrollmentDuplicatesAlertComponent
  ],
  exports: [HomeComponent]
})
export class HomeModule { }
